module.exports = __webpack_public_path__ + "img/hire.e8f8ab48.svg";